import { render, staticRenderFns } from "./BookingChooseLocation.vue?vue&type=template&id=c1cfedde&scoped=true&lang=pug&"
import script from "./BookingChooseLocation.vue?vue&type=script&lang=ts&"
export * from "./BookingChooseLocation.vue?vue&type=script&lang=ts&"
import style0 from "./BookingChooseLocation.vue?vue&type=style&index=0&id=c1cfedde&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cfedde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VFlex,VLayout,VTextField})
